import { FaRegUser, FaSearchengin } from "react-icons/fa6";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import helper from "../../utils/helper";
import NotFound from "../shared/NotFound";
import sanitizeHTML from "../../utils/sanitize";

export default function Content() {
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({});
    const [search, setSearch] = useState<string>('');
    const [category, setCategory] = useState<string>('');
    const [currentPage, setCurrentPage] = useState<number>(1);

    const getData = async (page: number = 1, search: string = '', category: string = '') => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/offer?page=${page}&search=${search}&category=${category}`
            );
            if (response && response.data && response.data.data) {
                setData(response.data.data.data);
                setPagination(response.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handlePageChange = async (page: number) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value);
    };

    const handleCategoryClick = (category: string) => {
        setCategory(category);
    };

    useEffect(() => {
        getData(currentPage, search, category);
    }, [currentPage, search, category]);

    const categories = [
        { label: 'All', value: '' },
        { label: 'Kredit', value: 'kredit' },
        { label: 'Deposito', value: 'deposito' },
        { label: 'Tabungan', value: 'tabungan' },
    ];

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16">
            <div className="flex flex-col-reverse md:flex-row md:justify-between gap-8">
                {/* Konten Penawaran */}
                <div className="flex-grow grid gap-y-10 w-full lg:max-w-4xl">
                    {data.length === 0 ? (
                        <NotFound></NotFound>
                    ) : (
                        data.map((item, index) => (
                            <Link key={index} to={`/detail-penawaran-terkini/${item.slug_title}`} className="hover:shadow-xl">
                                <div className="w-full h-full md:h-full rounded-xl overflow-hidden shadow-lg flex flex-col">
                                    <div className="w-full h-[200px] md:h-[400px]">
                                        <LazyLoadImage
                                            src={process.env.REACT_APP_API_ENDPOINT + "/offer/getimg/" + item.img_offer}
                                            alt="offers"
                                            effect="blur"
                                            className="w-full h-full object-cover object-top"
                                            wrapperProps={{
                                                style: { transitionDelay: '1s' },
                                            }}
                                        />
                                    </div>
                                    <div className="flex-grow flex flex-col justify-between p-3">
                                        <div>
                                            <div className="flex flex-row justify-between items-center text-[#B9B9B9] mb-2">
                                                <div className="flex items-center space-x-2">
                                                    <FaRegUser /> <span className="text-sm pt-1" dangerouslySetInnerHTML={{ __html: item.author.name }}></span>
                                                </div>
                                                <div className="flex justify-end">
                                                    <span className="text-sm pt-1 ml-auto">{new Date(item.created_at).toLocaleDateString()}</span>
                                                </div>
                                            </div>
                                            <div className="text-sm text-[#B9B9B9]">{item.category}</div>
                                            <div className="font-poppinsBold text-sm mt-2 mb-4" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                                            <p className="text-textPrimary mt-3" dangerouslySetInnerHTML={{ __html: helper.handleDescription(item.description, 50) }} />
                                        </div>
                                        <div className="pt-2">
                                            <span className="font-poppinsRegular text-bprDarkBlue text-[12px]">
                                                {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(item.offer_start_date))} - {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(item.offer_end_date))}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))
                    )}

                    <div className="mt-10 ">
                        {pagination.total > 0 && (
                            <nav aria-label="Page navigation example" className="flex justify-end">
                                <ul className="inline-flex -space-x-px text-base h-10">
                                    <li>
                                        <button
                                            onClick={() => handlePageChange(pagination.current_page - 1)}
                                            disabled={!pagination.prev_page_url}
                                            className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                                        >
                                            &laquo; Previous
                                        </button>
                                    </li>
                                    {pagination.links &&
                                        pagination.links.map((link: any, index: number) =>
                                            link.url && link.label !== '&laquo; Previous' && link.label !== 'Next &raquo;' ? (
                                                <li key={index}>
                                                    <button
                                                        onClick={() =>
                                                            handlePageChange(Number(new URL(link.url).searchParams.get('page')))
                                                        }
                                                        className={`flex items-center justify-center px-4 h-10 leading-tight ${link.active ? 'text-blue-600 bg-blue-50' : 'text-gray-500 bg-white'
                                                            } border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                                                    >
                                                        {link.label}
                                                    </button>
                                                </li>
                                            ) : null
                                        )}
                                    <li>
                                        <button
                                            onClick={() => handlePageChange(pagination.current_page + 1)}
                                            disabled={!pagination.next_page_url}
                                            className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                                        >
                                            Next &raquo;
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>
                </div>

                {/* Sidebar Pencarian */}
                <div className="border p-8 w-full md:sticky top-24 h-full md:w-1/3">
                    <span className="flex text-xl font-poppinsBold">Pencarian</span>
                    <div className="flex items-center justify-start w-full sm:items-center sm:justify-end mt-5">
                        <div className="relative w-full sm:w-full">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearchChange}
                                placeholder="Search..."
                                className="py-2 pl-10 pr-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-bprDarkBlue text-sm w-full"
                            />
                            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                                <FaSearchengin className="text-sm" />
                            </span>
                        </div>
                    </div>
                    <div className="mt-5">
                        <span className="flex text-xl font-poppinsBold">Kategori</span>
                        <div className="mt-4 overflow-x-auto">
                            <div className="flex space-x-3">
                                {categories.map((categoryItem) => (
                                    <button
                                        key={categoryItem.value}
                                        onClick={() => handleCategoryClick(categoryItem.value)}
                                        className={`py-1 px-3 rounded ${category === categoryItem.value ? 'bg-bprDarkBlue text-white' : 'bg-white text-bprDarkBlue border border-bprDarkBlue'}`}
                                    >
                                        {categoryItem.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="mt-5">
                        <span className="flex text-xl font-poppinsBold">Terbaru</span>
                        <div className="mt-4 space-y-5">
                            {data.slice(0, 5).map((item, index) => (
                                <Link
                                    key={index}
                                    to={`/detail-penawaran-terkini/${item.slug_title}`}
                                    className="flex space-x-4"
                                >
                                    <div className="w-28 h-20 flex-shrink-0">
                                        <LazyLoadImage
                                            src={`${process.env.REACT_APP_API_ENDPOINT}/offer/getimg/${item.img_offer}`}
                                            alt="offers"
                                            effect="blur"
                                            className="w-full h-full object-cover object-top rounded-md"
                                            wrapperProps={{
                                                style: { transitionDelay: "1s" },
                                            }}
                                        />
                                    </div>
                                    <div className="flex flex-col">
                                        <span
                                            className="font-poppinsBold"
                                            dangerouslySetInnerHTML={{ __html: item.title }}
                                        ></span>
                                        <span className="font-poppinsRegular text-textPrimary">
                                            {new Date(item.created_at).toLocaleDateString()}
                                        </span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
